import { render, staticRenderFns } from "./addIntent.vue?vue&type=template&id=7517f22a&scoped=true"
import script from "./addIntent.vue?vue&type=script&lang=js"
export * from "./addIntent.vue?vue&type=script&lang=js"
import style0 from "./addIntent.vue?vue&type=style&index=0&id=7517f22a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7517f22a",
  null
  
)

export default component.exports